import React from 'react';
import { FlexCrate, FlexCrateProps, Icon, Text } from '@perch-labs/shrike';
import { copyFor } from 'config';
import { formatDate } from '@perch-labs/warbler';

const getCopy = copyFor('billing.statement.utilityStatementSummary');

interface UtilityStatementSummaryProps extends FlexCrateProps {
  accountNumber: string;
  serviceAddress: string;
  serviceEndDate: string;
  serviceStartDate: string;
  textStyle?: StyleProps['textStyle'];
  iconScale?: number;
  periodLabel: 'servicePeriod' | 'productionPeriod';
}

export const UtilityStatementSummary = ({
  accountNumber,
  serviceAddress,
  serviceEndDate,
  serviceStartDate,
  textStyle = 'paragraph500',
  iconScale = 2,
  periodLabel,
  ...crateProps
}: UtilityStatementSummaryProps): JSX.Element => {
  return (
    <FlexCrate {...crateProps} flexDirection="column">
      <FlexCrate alignItems="start">
        <Icon icon="CalendarInverted" scale={iconScale} margin="4px 0 0 0" />
        <Text textStyle={textStyle} margin="0 0 0 8px">
          {getCopy(periodLabel, {
            start: formatDate(serviceStartDate, { format: 'MMM d' }),
            end: formatDate(serviceEndDate, { format: 'MMM d' }),
          })}
        </Text>
      </FlexCrate>
      <FlexCrate alignItems="start">
        <Icon icon="HomeInverted" scale={iconScale} margin="4px 0 0 0" />
        <Text textStyle={textStyle} margin="0 0 0 8px">
          {getCopy('serviceAddress', {
            address: serviceAddress,
          })}
        </Text>
      </FlexCrate>
      <FlexCrate alignItems="start">
        <Icon icon="DocumentInverted" scale={iconScale} margin="4px 0 0 0" />
        <Text textStyle={textStyle} margin="0 0 0 8px">
          {getCopy('utilityAccountNumber', {
            number: accountNumber,
          })}
        </Text>
      </FlexCrate>
    </FlexCrate>
  );
};
